import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2, AlertCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

const AuthCallback = () => {
  const { processGoogleSession } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL hash
        const hash = location.hash;
        console.log('[AuthCallback] Processing hash:', hash);
        
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          console.error('[AuthCallback] No session_id found in URL');
          setError('Brak identyfikatora sesji. Spróbuj zalogować się ponownie.');
          return;
        }

        const sessionId = sessionIdMatch[1];
        console.log('[AuthCallback] Session ID found:', sessionId.substring(0, 20) + '...');
        
        const userData = await processGoogleSession(sessionId);
        console.log('[AuthCallback] User data received:', userData?.email);
        
        // Navigate based on user type
        if (userData.user_type === 'company') {
          navigate('/dashboard/company', { state: { user: userData } });
        } else {
          navigate('/dashboard/individual', { state: { user: userData } });
        }
      } catch (error) {
        console.error('[AuthCallback] Auth error:', error);
        setError(error.message || 'Wystąpił błąd podczas logowania. Spróbuj ponownie.');
      }
    };

    processAuth();
  }, [location, processGoogleSession, navigate]);

  if (error) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4" data-testid="auth-callback-error">
        <div className="text-center max-w-md">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <AlertCircle className="w-8 h-8 text-red-500" />
          </div>
          <h2 className="text-xl font-semibold text-slate-900 mb-2">Błąd logowania</h2>
          <p className="text-slate-600 mb-6">{error}</p>
          <Button 
            onClick={() => navigate('/login')}
            className="bg-orange-500 hover:bg-orange-600"
          >
            Wróć do logowania
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <Loader2 className="w-10 h-10 text-orange-500 animate-spin mx-auto mb-4" />
        <p className="text-slate-600">Przetwarzanie logowania...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
